/*
 * Pasture — Sistema Gestionale per Centri Federali d'Asilo
 * Copyright © 2025-2026 Alberto Tacconi. Tutti i diritti riservati.
 *
 * Questo software è proprietà esclusiva di Alberto Tacconi.
 * L'utilizzo attuale presso il CFA è concesso a titolo gratuito,
 * non esclusivo e revocabile. Nessun diritto di proprietà, licenza
 * permanente o cessione è implicito o trasferito a terzi.
 *
 * Qualsiasi riproduzione, distribuzione, modifica o utilizzo non
 * autorizzato è vietato.
 */

import React from 'react';

export const CopyrightFooter: React.FC<{ className?: string }> = ({ className = '' }) => (
  <footer className={`w-full text-center text-xs text-muted-foreground py-2 select-none ${className}`}>
    &copy; 2025-2026 Alberto Tacconi &middot; Tutti i diritti riservati
  </footer>
);
